<template>
  <v-card flat>
    <v-card-text
      class="px-0"
      style="min-height: 55vh"
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
          lg="4"
        >
          <v-row class="align-center">
            <v-col
              cols="12"
              class="pl-4"
            >
              <v-card class="edit-elem">
                <div class="pa-3">
                  <v-autocomplete
                    id="startPageType"
                    v-model="settings.homePageType"
                    open-on-clear
                    dense
                    :items="homePageTypes"
                    label="Start Page Design"
                    item-text="label"
                    item-value="id"
                    outlined
                    hide-details
                  />
                  <div
                    v-if="settings.homePageType === 3"
                    class="hint mt-2"
                  >
                    Add label and content for aboutus under helpers.
                  </div>
                </div>
                <v-divider />
                <v-card-text
                  v-if="settings.homePageType && settings.homePageType !== 2"
                  class="pa-3"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-checkbox
                        v-model="settings.showLogo"
                        hide-details
                        label="Display Logo"
                        class="mt-0"
                      />
                    </v-col>
                    <v-col
                      v-if="settings.showLogo"
                      cols="12"
                      md="6"
                    >
                      <v-autocomplete
                        id="logo_positions"
                        v-model="settings.logoPosition"
                        open-on-clear
                        dense
                        :items="logoPositions"
                        label="Logo Position"
                        item-text="label"
                        item-value="id"
                        outlined
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="settings.showAboutInfo"
                hide-details
                label="Enable AboutUs"
                class="mt-0"
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="settings.enableTerms"
                hide-details
                label="Enable Terms and Conditions"
                class="mt-0"
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="settings.enableTermsInfo"
                hide-details
                label="Enable Terms and Conditions Info"
                class="mt-0"
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                id="checkout_options"
                v-model="settings.checkoutOptions"
                open-on-clear
                dense
                :items="paymentOptions"
                label="Checkout Options"
                item-text="label"
                item-value="id"
                outlined
                clearable
                hide-details
                multiple
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                id="level_one_template"
                v-model="settings.firstLvlTemplate"
                open-on-clear
                dense
                :items="levelOneTemplateOptions"
                label="Level One Template"
                item-text="label"
                item-value="id"
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                id="level_two_template"
                v-model="settings.secondLvlTemplate"
                open-on-clear
                dense
                :items="levelTwoTemplateOptions"
                label="Level Two Template"
                item-text="label"
                item-value="id"
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                id="menu_template"
                v-model="settings.menuTemplate"
                open-on-clear
                dense
                :items="menuTemplateOptions"
                label="Menu Template"
                item-text="label"
                item-value="id"
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="settings.hideTotalInCart"
                hide-details
                label="Hide Total Amount In Cart"
                class="mt-0"
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="settings.menuInstruction"
                hide-details
                label="Disable Menu Instruction"
                class="mt-0"
              />
            </v-col>
            <v-col
              cols="12"
              class="pl-4"
            >
              <v-card class="edit-elem">
                <v-card-title class="d-flex align-center pa-3">
                  Menu Hierarchy
                  <v-spacer />
                  <v-btn
                    v-if="!enableHierarchy"
                    outlined
                    small
                    color="primary"
                    @click="editHierarchy()"
                  >
                    Customize
                  </v-btn>
                  <v-btn
                    v-if="enableHierarchy"
                    outlined
                    small
                    color="primary"
                    @click="resetToDefault"
                  >
                    Reset To default
                  </v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text v-if="enableHierarchy">
                  <v-row>
                    <v-col
                      cols="12"
                      class="pt-0"
                    >
                      <v-list
                        dense
                        class="py-0"
                      >
                        <v-list-item class="px-0">
                          <v-list-item-action>
                            <v-checkbox
                              v-model="hierarchy.levelOne.enable"
                            />
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-autocomplete
                              id="first_level_id"
                              v-model="hierarchy.levelOne.levelId"
                              open-on-clear
                              dense
                              :items="levels"
                              label="Level One"
                              item-text="label"
                              item-value="id"
                              outlined
                              clearable
                              hide-details
                              :disabled="!hierarchy.levelOne.enable"
                              required
                              @change="
                                verifyDuplicateData(
                                  'levelOne',
                                  hierarchy.levelOne.levelId
                                )
                              "
                            />
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="px-0">
                          <v-list-item-action>
                            <v-checkbox
                              v-model="hierarchy.levelTwo.enable"
                            />
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-autocomplete
                              id="second_level_id"
                              v-model="hierarchy.levelTwo.levelId"
                              open-on-clear
                              dense
                              :items="levels"
                              label="Level Two"
                              item-text="label"
                              item-value="id"
                              outlined
                              hide-details
                              clearable
                              required
                              :disabled="!hierarchy.levelTwo.enable"
                              @change="
                                verifyDuplicateData(
                                  'levelTwo',
                                  hierarchy.levelTwo.levelId
                                )
                              "
                            />
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="px-0">
                          <v-list-item-action>
                            <v-checkbox
                              v-model="hierarchy.levelThree.enable"
                            />
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-autocomplete
                              id="third_level_id"
                              v-model="hierarchy.levelThree.levelId"
                              open-on-clear
                              dense
                              :items="levels"
                              label="Level Three"
                              item-text="label"
                              item-value="id"
                              outlined
                              clearable
                              hide-details
                              :disabled="!hierarchy.levelThree.enable"
                              required
                              @change="
                                verifyDuplicateData(
                                  'levelThree',
                                  hierarchy.levelThree.levelId
                                )
                              "
                            />
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="6"
          sm="4"
        >
          <v-row class="align-center">
            <v-col cols="12">
              <v-checkbox
                v-model="settings.isServiceChargeEditable"
                hide-details
                label="Enable to edit Service Charges"
                class="mt-0"
              />
            </v-col>
            <v-col cols="12">
              <v-data-table
                v-if="settings.isServiceChargeEditable"
                :headers="serviceChargeheaders"
                :items="serviceChargeOptions"
                hide-default-footer
                mobile-breakpoint="0"
                hide-sort
              >
                <template v-slot:item.emoji="{ item }">
                  <v-text-field
                    v-model="item.emoji"
                    dense
                    outlined
                    hide-details
                  />
                </template>
                <template v-slot:item.percentage="{ item }">
                  <v-text-field
                    v-model="item.percentage"
                    type="number"
                    min="0"
                    dense
                    outlined
                    hide-details
                    suffix="%"
                    @input="handlePercentageInput($event, item)"
                  />
                </template>
                <template v-slot:item.notes="{ item }">
                  <v-textarea
                    v-model="item.notes"
                    outlined
                    hide-details
                    dense
                    class="py-2"
                    rows="2"
                  />
                </template>
                <template v-slot:item.actions="{ item, index }">
                  <v-icon
                    v-if="index > 2"
                    color="error"
                    @click="removeRow(index)"
                  >
                    mdi-close
                  </v-icon>
                </template>
                <template v-slot:footer>
                  <div class="d-flex justify-center py-3">
                    <v-btn
                      outlined
                      color="primary"
                      @click="addRow"
                    >
                      <v-icon class="pr-2">
                        mdi-plus
                      </v-icon>
                      Add
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="settings.districtPayBetaTest"
                hide-details
                label="Enable District Pay Beta Test"
                class="mt-0"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-3">
      <v-spacer />
      <v-btn
        color="error"
        @click="close()"
      >
        Close
      </v-btn>
      <v-btn
        color="success"
        @click="save()"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "ContactlessSettings",
  props: {
    id: {
      type: Number || null,
      default: null
    },
    themeInfo: {
      type: Object,
      required: true
    },
    enable: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      loader: false,
      homePageTypes: [
        { id: 1, label: "Home Page - Default" },
        { id: 2, label: "Home Page - Full Image" },
        { id: 3, label: "Home Page - About Us Page" },
        { id: 4, label: "Home Page - Level One Page" }
      ],
      logoPositions: [
        { id: 1, label: "Top" },
        { id: 2, label: "Bottom" }
      ],
      dataLevels: [
        { id: "_department", label: "Departments", jsonKey:"departments" },
        { id: "_course", label: "Courses", jsonKey:"courses" },
        { id: "_cuisine", label: "Cuisines", jsonKey:"cuisines" },
        { id: "_category", label: "Categories", jsonKey:"categories" },
        { id: "_tag", label: "Tags  (Usage Type - As Dept or Cuisines or Categories)", jsonKey:"tagItems" }
      ],
      accountId: parseInt(this.$route.params.accountId),
      field: "settings",
      enableHierarchy : false,
      hierarchy:  null,
      hierarchyBk:  null,
      selectedLevelData : [],
      isValid : false,
      validDataSelected : false,
      paymentOptions: [
        { id: 1, label: "Request Bill" },
        { id: 2, label: "Online Payment" },
        { id: 3, label: "Zomato Payment" },
        { id: 4, label: "Obvvy Payment" }
      ],
      levelOneTemplateOptions: [
        { id: 1, label: "Box View (Default)" },
        { id: 2, label: "Text View (List View)" }
      ],
      levelTwoTemplateOptions: [
        { id: 1, label: "Text View (Default)" },
        { id: 2, label: "Image View" },
        { id: 3, label: "Text View (List View)" }
      ],
      menuTemplateOptions: [
        { id: 1, label: "List View (Default)" },
        { id: 2, label: "Card View" },
        { id: 3, label: "Card View (Action Button)" },
        { id: 4, label: "Cigar View" }
      ],
      serviceChargeheaders: [
        { text: "Emoji", value: "emoji", width: "120px" },
        { text: "Percentage", value: "percentage", width: "120px" },
        { text: "Notes", value: "notes", width: "250px" },
        { text: "", value: "actions", width: "70px" }
      ],
      serviceChargeOptions: [
        { emoji: "😞", percentage: 0, notes: "" },
        { emoji: "😊", percentage: 5, notes: "" },
        { emoji: "😄", percentage: 7.5, notes: "" }
      ]
    };
  },
  computed: {
    settings() {
      return this.themeInfo.settings || {};
    },
    levels() {
      let lvls = JSON.parse(JSON.stringify(this.dataLevels));
      let selectedData = JSON.parse(JSON.stringify(this.selectedLevelData));
      lvls.forEach((dat) => {
        dat.disabled = selectedData.includes(dat.id);
      });
      return lvls;
    }
  },
  watch: {
    "settings.checkoutOptions"(val) {
      if (!val) return;
      const present = [2, 3, 4].filter((n) => val.includes(n));
      if (present.length > 1) {
        const keep = present.reduce((a, b) => (val.lastIndexOf(a) > val.lastIndexOf(b) ? a : b));
        present.filter((n) => n !== keep).forEach((n) => val.splice(val.indexOf(n), 1));
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    verifyDuplicateData(level, dataKey) {
      if (!dataKey) {
        // On clear
        let prevSelected =
          this.hierarchyBk &&
          this.hierarchyBk[level] &&
          this.hierarchyBk[level].levelId;
        this.selectedLevelData.splice(
          this.selectedLevelData.indexOf(prevSelected),
          1
        ); // remove prev selected in temp array
      } else {
        if (!this.selectedLevelData.includes(dataKey)) {
          this.selectedLevelData.push(dataKey);
          this.hierarchyBk = JSON.parse(JSON.stringify(this.hierarchy));
        }
      }
      let info = this.dataLevels.filter((d) => {
        return d.id === dataKey;
      });
      this.hierarchy[level].jsonKey = info[0].jsonKey;
    },
    resetToDefault() {
      this.enableHierarchy = false;
      this.hierarchy = null;
      this.hierarchyBk = null;
    },
    editHierarchy() {
      this.enableHierarchy = true;
      this.hierarchy = {
        levelOne: { enable: false, levelId: "", jsonKey: "" },
        levelTwo: { enable: false, levelId: "", jsonKey: "" },
        levelThree: { enable: false, levelId: "", jsonKey: "" }
      };
      this.hierarchyBk = JSON.parse(JSON.stringify(this.hierarchy));
    },
    save() {
      this.settings.menuHierarchy = this.hierarchy;
      console.log(this.themeInfo);
      let formIns = this.themeInfo;
      this.settings.serviceChargeOptions = this.serviceChargeOptions;

      if (this.settings.isServiceChargeEditable) {
       const isValid = this.validateServiceChargeOptions();
        if (!isValid) return; 
  }

      let url = `${this.ADMIN_API_URL}/accounts/${this.accountId}/contactless`;
      let q;
      if (this.id) {
        q = this.$http.put(`${url}/${this.id}`, formIns);
      } else {
        q = this.$http.post(`${url}`, formIns);
      }
      q.then(
        (res) => {
          this.$store.commit("showSnackbar", {
            timeout: 3000,
            message: res.body.message
          });
          this.close();
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },

    init() {
      if (this.settings.menuHierarchy) {
        this.enableHierarchy = true;
        this.hierarchy = this.settings.menuHierarchy || null;
      }
      if (this.settings.serviceChargeOptions) {
        this.serviceChargeOptions = this.settings.serviceChargeOptions;
      }
    },
    close() {
      this.$emit("close");
    },
    addRow() {
      this.serviceChargeOptions.push({
        emoji: "",
        percentage: null,
        notes: ""
      });
    },
    removeRow(index) {
      this.serviceChargeOptions.splice(index, 1);
    },
    validateServiceChargeOptions() {
  const seen = new Set();

  for (let i = 0; i < this.serviceChargeOptions.length; i++) {
    const value = this.serviceChargeOptions[i].percentage;

    // 1️Check empty / invalid
    if (value === null || value === "" || isNaN(value)) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        color: "error",
        message: `Percentage is required in row ${i + 1}`
      });
      return false;
    }

    // 2️ Check duplicate
    if (seen.has(Number(value))) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        color: "error",
        message: `Duplicate percentage found: ${value}%`
      });
      return false;
    }

    seen.add(Number(value));
  }

  return true;
},
  
handlePercentageInput(val, item) {
  if (val === "" || val === null) {
    item.percentage = null;
    return;
  }

  const number = Number(val);

  // Prevent negative
  if (number < 0) {
    item.percentage = 0;
    return;
  }

  item.percentage = number;
}
  }
};
</script>

<style lang="scss">
.edit-elem {
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2) !important;
  min-height: 45px;
  // max-width: 522px;

  .v-card__title {
    color: grey !important;
  }

  &.terms {
    min-height: unset;
    max-width: 700px;
  }
}

.settings-cont {
  flex-direction: column;
  align-items: flex-start !important;
}

.hint {
  padding-left: 3px;
  line-height: 12px;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  hyphens: auto;
  color: rgba(0, 0, 0, 0.6);
}
</style>
